import { createContext, useContext } from 'react';

// Provides the current pathname for SSR-safe routing.
// Client entry reads window.location.pathname; SSR entry injects the URL directly.
export const RouteContext = createContext('/');

export function useRoute(): string {
  return useContext(RouteContext);
}
